var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{class:{ show: _vm.show }},[_c('div',{staticClass:"rollover",on:{"click":function($event){_vm.show = !_vm.show}}},[(_vm.show)?_c('span',[_vm._v("<")]):_c('span',[_vm._v(">")])]),_c('div',{staticClass:"inside"},[_c('logo'),_c('savedMatch')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }